import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_COLLECTION_CONSTANT_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_CONSTANT_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_CONSTANT_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_CONSTANT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteCollectionConstant(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_CONSTANT_BEGIN,
    });
    const { projectId, version, collectionUuid, constantId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/constants/${collectionUuid}/collection/${constantId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_CONSTANT_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Deleted collection constant');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_CONSTANT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete collection constant');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_CONSTANT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete collection constant');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionConstantError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_CONSTANT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_CONSTANT_BEGIN:
      return {
        ...state,
        deleteCollectionConstantPending: true,
        deleteCollectionConstantError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_CONSTANT_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index].constants = action.data;
      return {
        ...state,
        deleteCollectionConstantPending: false,
        deleteCollectionConstantError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          constants: action.data,
        },
      };

    case COLLECTIONS_DELETE_COLLECTION_CONSTANT_FAILURE:
      return {
        ...state,
        deleteCollectionConstantPending: false,
        deleteCollectionConstantError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_CONSTANT_DISMISS_ERROR:
      return {
        ...state,
        deleteCollectionConstantError: null,
      };

    default:
      return state;
  }
}
